// extracted by mini-css-extract-plugin
export default {"success":"success-89e35","info":"info-89e35","warning":"warning-89e35","error":"error-89e35","shine":"shine-89e35"};